/** Declaration for the createUnityInstance function */
declare function createUnityInstance(canvas: HTMLElement, config: any, onProgress: (progress: number) => void): Promise<any>;

/** Declaration for the UnityInstance class */
declare class UnityInstance {
  public SendMessage(gameObjectName: string, methodName: string, message?: string): void;
}

/** Handler for Unity WebGL app */
class UnityHandler {

  public static instance: UnityInstance | null = null;

  private static readonly buildUrl: string = "/Build";
  private static readonly loaderUrl: string = UnityHandler.buildUrl + "/Build.loader.js";
  private static readonly dataUrl: string = UnityHandler.buildUrl + "/Build.data.gz";
  private static readonly frameworkUrl: string = UnityHandler.buildUrl + "/Build.framework.js.gz";
  private static readonly codeUrl: string = UnityHandler.buildUrl + "/Build.wasm.gz";

  private static readonly config = {
    dataUrl: UnityHandler.dataUrl,
    frameworkUrl: UnityHandler.frameworkUrl,
    codeUrl: UnityHandler.codeUrl,
    streamingAssetsUrl: "StreamingAssets",
    companyName: "MagTech",
    productName: "UberDesigner",
    productVersion: "0.1.0",
    showBanner: this.unityShowBanner,
    matchWebGLToCanvasSize: true,
    devicePixelRatio: 1
    // By default Unity keeps WebGL canvas render target size matched with
    // the DOM size of the canvas element (scaled by window.devicePixelRatio)
    // Set this to false if you want to decouple this synchronization from
    // happening inside the engine, and you would instead like to size up
    // the canvas DOM size and WebGL render target sizes yourself.
    // config.matchWebGLToCanvasSize = false;
  };

  public static init(setShop: () => void): void {
    //let container: HTMLElement = document.querySelector<HTMLElement>("#unity-container")!;
    let canvas: HTMLElement = document.querySelector<HTMLElement>("#unity-canvas")!;
    let loadingBar: HTMLElement = document.querySelector<HTMLElement>("#unity-loading-bar")!;
    let progressBarFull: HTMLElement = document.querySelector<HTMLElement>("#unity-progress-bar-full")!;

    // Show loading bar
    loadingBar.style.display = "block";

    window.addEventListener('resize', () => {
      console.log("resize");
      //getBounds();
      //resizeCanvas(canvas);
    });

    // Set meta info according to device type
    if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
      // Mobile device style: fill the whole browser client area with the game canvas:
      let meta: HTMLMetaElement = document.createElement('meta');
      meta.name = 'viewport';
      meta.content = 'width=device-width, height=device-height, initial-scale=1.0, user-scalable=no, shrink-to-fit=yes';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }

    // Create Unity instance by injecting the loader script
    let script: HTMLScriptElement = document.createElement("script");
    script.src = UnityHandler.loaderUrl;

    script.onload = () => {
      createUnityInstance(canvas, UnityHandler.config, (progress: number) => {
        progressBarFull.style.width = 100 * progress + "%";
      }).then((unityInstance: UnityInstance) => {
        // Set the Unity instance
        UnityHandler.instance = unityInstance;

        // Hide loading bar
        loadingBar.style.display = "none";

        setShop(); // set shop first as soon as possible, otherwise unity won't do shit!
        //resizeCanvas(canvas);

      }).catch((message: string) => {
        alert(message);
      });
    };
    document.body.appendChild(script);
  }

  /** Shows a temporary message banner/ribbon for a few seconds, or
    * a permanent error message on top of the canvas if type=='error'.
    * If type=='warning', a yellow highlight color is used.
    * Modify or remove this function to customize the visually presented
    * way that non-critical warnings and error messages are presented to the
    * user.
    */
  private static unityShowBanner(msg: string, type: string) {
    let warningBanner: HTMLElement = document.querySelector<HTMLElement>("#unity-warning")!;

    function updateBannerVisibility() {
      warningBanner.style.display = warningBanner.children.length ? "block" : "none";
    }

    let div: HTMLDivElement = document.createElement("div");
    div.innerHTML = msg;
    div.style.padding = "10px";
    warningBanner.appendChild(div);

    if (type === "error") {
      div.style.backgroundColor = "red";
    } else {
      if (type === 'warning') {
        div.style.backgroundColor = "yellow";
      }
      setTimeout(function() {
        warningBanner.removeChild(div);
        updateBannerVisibility();
      }, 5000);
    }
    updateBannerVisibility();
  }
}

export default UnityHandler;
